import React            from "react";
import moment           from 'moment';
import DownloadBtn      from 'assets/icons/Download.svg';

function MedicalCertificateTable({mc, getDaysDiff}) {
  return (
    <div className="medical-certificate-info">
      {mc?.id &&
        <div className="d-flex mb-2">
          <div className="mc-label">Issued On</div>
          <div className="mc-value">
            : 
            <span className="font-weight-bold pl-2">{moment(mc.issue_date).format('Do MMM YYYY')}</span>
            <a href={mc?.document} className="download-mc ml-3" target="_blank" rel="noreferrer"><img src={ DownloadBtn } alt="download-btn" /></a>
          </div>
        </div>
      }
      
      <div className="d-flex mb-2">
        <div className="mc-label">Date</div>
        <div className="mc-value">
          : <span className="font-weight-bold pl-2">{moment(mc.start_date).format('Do MMM YYYY')}</span> To <span className="font-weight-bold">{moment(mc.end_date).format('Do MMM YYYY')}</span>
        </div>
      </div>

      <div className="d-flex mb-2">
        <div className="mc-label">Day(s)</div>
        <div className="mc-value">
          : <span className="font-weight-bold pl-2">{getDaysDiff(mc.start_date, mc.end_date)}</span>
        </div>
      </div>
    </div>
  );
}

export default MedicalCertificateTable;
